import { render } from "./DoneView.vue?vue&type=template&id=5f988e08&scoped=true"
import script from "./DoneView.vue?vue&type=script&lang=js"
export * from "./DoneView.vue?vue&type=script&lang=js"

import "./DoneView.vue?vue&type=style&index=0&id=5f988e08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f988e08"]])

export default __exports__